import { FC, useState } from "react";
import { TodoItemObject } from "types/todolist";
import EditTask from "./EditTask";
import ViewTask from "./ViewTask";

const TodoItem: FC<{
  item: TodoItemObject;
  onClose: () => void;
  mutate: any;
  tab?: string;
  mutateOverdue?: any;
}> = ({ item, onClose, mutate, tab = "today", mutateOverdue }) => {
  const [open, setOpen] = useState(false);
  const getOpenStatus = (openStatus: boolean) => {
    setOpen(openStatus);
  };

  return open ? (
    <EditTask
      type="update"
      item={item}
      onClose={onClose}
      getOpenStatus={getOpenStatus}
      mutate={mutate}
      mutateOverdue={mutateOverdue}
    />
  ) : (
    <ViewTask
      item={item}
      getOpenStatus={getOpenStatus}
      tab={tab}
      mutate={mutate}
      mutateOverdue={mutateOverdue}
    />
  );
};
export default TodoItem;
